import React from 'react';
import ApiEnum from "../constants/ApiEnum";
import ReactMapboxGl, {Marker} from "react-mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';
import Geocode from "react-geocode";
import StoreListItem from "./stores/StoreListItem";
import StoreMainItem from "./stores/StoreMainItem";
import logo from "../images/marker-tax.png";
import mylocation from "../images/my-location.png";
import mylocationinmap from "../images/my-location-in-map.png";
import Loader from 'react-loader-spinner'
import mapboxgl from 'mapbox-gl';
import ReactGA from 'react-ga';
import {geolocated} from "react-geolocated";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const Map = ReactMapboxGl({
    accessToken: 'pk.eyJ1IjoiaWRvdHdlYmVuZ2luZWVycyIsImEiOiJja3RiN3liMjgwMG5qMnBtYXZjbWp1aTlwIn0.BPLf50A15h6xeDTG1Y4FHw'
});

const trackingId = "UA-23318990-1"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);

class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            urlMap: null,
            urlList: null,
            store: {
                data: false,
                error: false
            },
            brand: {
                data: false,
                error: false
            },
            brandFilter: 1,
            specialism: {
                data: false,
                error: false
            },
            specialismFilter: 1,
            sortFilter: 1,
            message: null,
            mainItemId: null,
            mapZoom: 7,
            mapLat: 52.092875,
            mapLng: 5.104480,
            markerLat: null,
            markerLng: null,
            locationSearch: false,
            searchValue: ''
        }

    }


    onSelected = (viewport, item) => {
        this.setState({
            mapZoom: 10,
            mapLat: viewport.latitude,
            mapLng: viewport.longitude,
            mapSearchInput: item.text,
        })
    }

    brandFilter = (event) => {
        this.setState({
            brandFilter: event.target.value
        });
    }

    specialismFilter = (event) => {
        this.setState({
            specialismFilter: event.target.value
        });
    }

    sortFilter = (event) => {
        this.setState({
            sortFilter: event.target.value
        });
    }

    componentDidMount() {
        this.setState({
            searchValue: this.props.searchValue
        })
        this.requestStores()
        // this.requestBrands()
        // this.requestSpecialisms()
        if (this.props.searchValue){
            this.requestStoresFilter(this.props.searchValue)
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'zoekVestiging',
                'zoekVestigingInput': this.props.searchValue
            });
        }
    }

    handleInputChange = (e) => {
        this.setState({
            searchValue: e.target.value
        })
    }


    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (e.target.value) {
                this.requestStoresFilter(e.target.value)
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'zoekVestiging',
                    'zoekVestigingInput': e.target.value
                });
            } else {
                this.requestStores()
            }
        }
    }

    onChangeLocationInput = (inputValue) => {
        Geocode.setApiKey("AIzaSyAb_YZ8839lEh45jAiQI5KSF6MqkQQgDrY");
        Geocode.setRegion("nl");
        Geocode.fromAddress(inputValue).then(
            response => {
                const {lat, lng} = response.results[0].geometry.location
                this.setState({
                    mapZoom: 10,
                    mapLat: lat,
                    mapLng: lng,
                    locationSearch: false,
                    markerLat: lat,
                    markerLng: lng,
                })
            },
            error => {
                console.error(error);
            }
        );
    };

    render() {

        const items = Object.values(this.state.store.data)

        return (

            <section className="c-locations c-locations--map" style={{backgroundColor: 'lightblue'}}>

                {!!this.state.locationSearch &&

                    <div className="c-locations-loader">
                        <Loader
                            type="TailSpin"
                            color="#E67A01"
                            height={60}
                            width={80}
                        />
                    </div>

                }

                <Map
                    style="mapbox://styles/idotwebengineers/cktbat1j07oub17qord1w4ja6"
                    zoom={[this.state.mapZoom]}
                    center={[this.state.mapLng, this.state.mapLat]}
                    containerStyle={{
                        height: '100%',
                        width: '100%'
                    }}
                    onMove={(map) => {

                        this.setState({
                            mapLng: map.getCenter().lng,
                            mapLat: map.getCenter().lat,
                            mapZoom: map.getZoom(),
                        });

                        const bounds = map.getBounds();

                        //smaller than
                        const mapMaxLat = bounds._ne.lat
                        const mapMaxLng = bounds._ne.lng

                        //greater than
                        const mapMinLat = bounds._sw.lat
                        const mapMinLng = bounds._sw.lng

                        for (const item in this.state.store.data) {

                            const itemLat = this.state.store.data[item].acfData.vestiging_data.google_maps_locatie.lat
                            const itemLng = this.state.store.data[item].acfData.vestiging_data.google_maps_locatie.lng

                            if (itemLat < mapMaxLat && itemLat > mapMinLat && itemLng < mapMaxLng && itemLng > mapMinLng) {
                                this.state.store.data[item].inBounds = true
                            } else {
                                this.state.store.data[item].inBounds = false
                            }

                        }

                    }}
                >

                    {!!this.state.store.data &&

                        Object.values(this.state.store.data).filter((data) => this._brandFilter(data, this.state.brandFilter)).filter((data) => this._specialismFilter(data, this.state.specialismFilter)).filter((data) => this._locationCheckFilter(data)).map((data) => (

                            <Marker
                                coordinates={[data.acfData.vestiging_data.google_maps_locatie.lng, data.acfData.vestiging_data.google_maps_locatie.lat]}
                                onClick={() => this.openMainItem(data.id)} anchor="bottom">
                                <img src={logo} alt="logo"/>
                            </Marker>

                        ))

                    }

                    {!!this.state.markerLng && this.state.markerLat &&
                    <Marker
                        coordinates={[this.state.markerLng, this.state.markerLat]}
                        >
                        <img class="my-location-marker" src={mylocationinmap} alt="logo"/>
                    </Marker>
                    }

                </Map>

                <button className="btn btn--orange c-locations__filter-btn js-openFilterBtn"><span>Filter</span>
                </button>
                <div className="c-locations__background"/>
                <aside className="c-locations__floating-filter">
                    <header>
                        <nav>
                            <a className="is-active" href={this.state.urlMap}><span>Kaartweergave</span></a>
                            <a href={this.state.urlList}><span>Lijstweergave</span></a>
                        </nav>
                    </header>
                    <div className="c-locations__floating-filter__body">
                        <h1>Vind een ABS vestiging</h1>
                        <p>
                            Zoek naar een vestiging bij u in de buurt
                        </p>
                        <div className="c-form">
                            <div className="c-form__row">
                                <div className="c-form__group">
                                    <label htmlFor="address">Postcode of plaatsnaam</label>
                                    <div className="c-form__icon-input">
                                        <i className="icon-pin"/>


                                        <input type="text" value={this.state.searchValue} className={"c-location-input"}
                                               placeholder={"Bijv. 2115GH of Amsterdam"}
                                               onKeyDown={this.handleKeyDown} onChange={this.handleInputChange}/>

                                            {((this.props.isGeolocationAvailable && this.props.isGeolocationEnabled)) &&

                                                <>
                                                {this.props.coords &&
                                                    <button className="c-form__location-button" onClick={() => {
                                                        this.setState(
                                                            {
                                                                searchValue: 'Huidige locatie',
                                                                mapZoom: 10,
                                                                mapLat: this.props.coords.latitude,
                                                                mapLng: this.props.coords.longitude,
                                                                markerLat: this.props.coords.latitude,
                                                                markerLng: this.props.coords.longitude
                                                            }
                                                        )
                                                    }}>
                                                        <img src={mylocation} alt="Huidige locatie"/>
                                                    </button>}
                                                </>}

                                            {!this.props.coords && <p>Uw huidige locatie laden...</p>}

                                    </div>
                                </div>
                            </div>

                            {/** <div className="c-form__row c-form__row--half">
                             <div className="c-form__group">
                             <label htmlFor="">Filter op</label>
                             <div className="c-form__select">
                             <i className="icon-arrow-down"/>
                             <select id="specialismFilter" defaultValue={"1"}
                             onChange={this.specialismFilter}
                             value={this.state.specialismFilter}>
                             <option value="1">Specialisatie</option>
                             {Object.values(this.state.specialism.data).map((data) => (
                                                <option value={data.id}>{data.name}</option>
                                            ))}
                             </select>
                             </div>
                             </div>
                             <div className="c-form__group">
                             <div className="c-form__select">
                             <i className="icon-arrow-down"/>
                             <select id="brandFilter" defaultValue={"1"} onChange={this.brandFilter}
                             value={this.state.brandFilter}>
                             <option value="1">Merk</option>
                             {Object.values(this.state.brand.data).map((data) => (
                                                <option value={data.id}>{data.name}</option>
                                            ))}
                             </select>
                             </div>
                             </div>
                             </div>
                             <div className="c-form__row">
                             <div className="c-form__group">
                             <label htmlFor="sort">Sorteren op</label>
                             <div className="c-form__select">
                             <i className="icon-arrow-down"/>
                             <select id="sort" defaultValue={"1"} onChange={this.sortFilter}
                             value={this.state.sortFilter}>
                             <option value="1">A-Z</option>
                             <option value="2">Z-A</option>
                             </select>
                             </div>
                             </div>
                             </div>*/}
                        </div>

                        {!!items &&
                            <h3>ABS vestigingen
                                ({items.filter((data) => this._brandFilter(data, this.state.brandFilter)).filter((data) => this._specialismFilter(data, this.state.specialismFilter)).filter((data) => data.inBounds).length})</h3>
                        }

                        {!!items &&
                            <div className="c-company-cards">

                                {items.filter((data) => this._brandFilter(data, this.state.brandFilter)).filter((data) => this._specialismFilter(data, this.state.specialismFilter)).filter((data) => data.inBounds).map((data) => (

                                    <StoreListItem {...data} openMainItem={this.openMainItem}/>

                                ))}

                            </div>
                        }

                    </div>
                </aside>
                {!!items &&
                    items.map((data) => (
                        <StoreMainItem {...data} openId={this.state.mainItemId} closeMainItem={this.closeMainItem}/>
                    ))}
            </section>
        )
    }

    _locationCheckFilter = (data) => {
        let show = false
        if (data.acfData.vestiging_data.google_maps_locatie.lng && data.acfData.vestiging_data.google_maps_locatie.lat) {
            show = true
        }
        return show
    }

    _brandFilter = (data, filterValue) => {

        let show = false
        filterValue = parseInt(filterValue)
        if (filterValue === 1) {
            show = true
        }
        if (data.acfData.relationele_data.merkerkenningen.includes(filterValue)) {
            show = true
        }
        return show
    }

    _specialismFilter = (data, filterValue) => {
        let show = false
        filterValue = parseInt(filterValue)
        if (filterValue === 1) {
            show = true
        }
        if (data.acfData.relationele_data.specialisme.includes(filterValue)) {
            show = true
        }
        return show
    }

    _sortFilter = (data, filterValue) => {
        filterValue = parseInt(filterValue)
        if (filterValue === 1) {
            data.sort(function (a, b) {
                var textA = a.companyName.toUpperCase();
                var textB = b.companyName.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        } else {
            data.sort(function (a, b) {
                var textA = a.companyName.toUpperCase();
                var textB = b.companyName.toUpperCase();
                return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
            });
        }
    }

    openMainItem = (id) => {
        this.setState({
            mainItemId: id,
        })
    }

    closeMainItem = () => {
        this.setState({
            mainItemId: null,
        })
    }

    requestStores = () => {

        this.setState({
            locationSearch: true
        })

        fetch(ApiEnum.Api + '/stores', {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
            return response.json()
        }).then((response) => {

            if (response.status.code === 200) {

                this.setState({
                    urlMap: response.linkMap,
                    urlList: response.linkList,
                    store: {
                        data: response.data,
                        error: response.status
                    },
                })

            } else {

                this.setState({
                    message: response.status.message
                })


            }
        }).then(() => {
            this.setState({
                mapZoom: 7,
                mapLat: 52.092875,
                mapLng: 5.104480,
                markerLat: null,
                markerLng: null,
                locationSearch: false
            })
        })

    }

    requestStoresFilter = (values) => {

        this.setState({
            locationSearch: true
        })

        fetch(ApiEnum.Api + '/stores-filter', {
            method: 'post',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
            return response.json()
        }).then((response) => {

            if (response.status.code === 200) {

                this.setState({
                    urlMap: response.linkMap,
                    urlList: response.linkList,
                    store: {
                        data: response.data,
                        error: response.status
                    },
                })

            } else {

                this.setState({
                    message: response.status.message
                })

            }
        }).then(() => {
            this.onChangeLocationInput(values)
        })

    }

    requestBrands = () => {

        fetch(ApiEnum.Api + '/brands', {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
            return response.json()
        }).then((response) => {

            if (response.status.code === 200) {

                this.setState({
                    brand: {
                        data: response.data,
                        error: response.status
                    },
                })

            } else {

                this.setState({
                    message: response.status.message
                })

            }
        })

    }

    requestSpecialisms = () => {

        fetch(ApiEnum.Api + '/specialism', {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
            return response.json()
        }).then((response) => {

            if (response.status.code === 200) {

                this.setState({
                    specialism: {
                        data: response.data,
                        error: response.status
                    },
                })

            } else {

                this.setState({
                    message: response.status.message
                })

            }
        })

    }


}

export default geolocated()(App);
